interface FormCardProps {
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export function FormCard({ title, actions, children }: FormCardProps) {
  return (
    <div className="border border-gray-400 rounded-lg shadow-sm flex flex-col items-start gap-3 overflow-hidden">
      <div className="flex flex-col md:flex-row justify-between w-full p-4 bg-blue-30 border-gray-400 border-b items-start md:items-center gap-2">
        <h3 className="text-lg font-semibold">{title}</h3>
        {actions}
      </div>
      <div className="flex flex-col divide-y divide-gray-200 w-full">
        {children}
      </div>
    </div>
  )
}

export function FormCardBlock({ children }: { children: React.ReactNode }) {
  return <div className="flex flex-col p-4 w-full gap-4 pb-6">{children}</div>
}

export function FormCardRow({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col md:flex-row w-full items-start md:items-center pb-2 gap-8">
      {children}
    </div>
  )
}

export function FormCardLeftColumn({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex md:flex-row md:w-6/12 md:max-w-64 items-start md:items-center gap-2 text-sm">
      {children}
    </div>
  )
}

export function FormCardRightColumn({
  children,
}: {
  children: React.ReactNode;
}) {
  return <div className="flex-grow md:max-w-64 w-full">{children}</div>
}
